export default __webpack_public_path__ + "static/media/produccionCreativa.fb91b5ff.svg";